import rankFragmentsWithMatchesCount from 'bl/client/rankFragmentsWithMatchesCount.bl';
import rankMatchesAtStartOfFragmentsCount from 'bl/client/rankMatchesAtStartOfFragmentsCount.bl';
import rankPerfectMatch from 'bl/client/rankPerfectMatch.bl';
import rankStartOfFirstFragment from 'bl/client/rankStartOfFirstFragment.bl';
import splitText from 'bl/client/splitText.bl';

const calculatePhoneRank = (options) => {
  const text = options?.text;
  const phone = options?.phone;

  const strings = splitText(phone);

  // let's score how well text matches user.phone
  let rank = 0;
  rank += rankPerfectMatch({ a: text, b: phone });
  rank += rankFragmentsWithMatchesCount({ text, strings });
  rank += rankMatchesAtStartOfFragmentsCount({ text, strings });
  rank += rankStartOfFirstFragment({ text, strings });

  return rank;
};

export default calculatePhoneRank;
